if(!customElements.get('ip-print-artwork'))customElements.define('ip-print-artwork',class extends HTMLElement{
connectedCallback(){
 if(this.ready)return;this.ready=true;
 const file=this.querySelector('[data-art-file]'),email=this.querySelector('[data-art-email]'),po=this.querySelector('[data-art-po]'),delivery=this.querySelector('[data-art-delivery]'),form=this.closest('form'),assistance=this.querySelector('[data-art-assistance]');
 const sync=()=>{
  const selected=file.files[0],hasFile=Boolean(selected),needsHelp=Boolean(assistance&&assistance.checked);
  const extensions=file.accept.split(',').filter(value=>value.startsWith('.'));
  const validFile=hasFile&&extensions.some(extension=>selected.name.toLowerCase().endsWith(extension));
  file.required=false;
  file.setCustomValidity(hasFile&&!validFile?this.dataset.invalid:'');
  email.required=!hasFile&&!needsHelp;
  email.setCustomValidity(!hasFile&&!needsHelp&&!email.checked?'Upload artwork or check the email-later acknowledgment.':'');
  const later=!hasFile&&!needsHelp&&email.checked;
  po.disabled=!later;po.required=later&&this.hasAttribute('data-reference-required');
  po.setCustomValidity(po.required&&!po.value.trim()?this.dataset.referenceError:'');this.querySelector('[data-art-reference]').hidden=!later;
  delivery.value=needsHelp?(hasFile?'Artwork assistance requested; file uploaded':'Artwork assistance requested; awaiting approved artwork'):hasFile?'Artwork uploaded':later?'Email artwork later':'';
 };
 file.addEventListener('change',()=>{if(file.files.length)email.checked=false;sync();});
 email.addEventListener('change',sync);
 if(assistance)assistance.addEventListener('change',sync);
 po.addEventListener('input',sync);
 po.addEventListener('change',sync);
 if(form){
  form.addEventListener('submit',event=>{if(this.hasAttribute('data-reference-required'))po.value=po.value.trim();sync();if(!file.checkValidity()||!email.checkValidity()||!po.checkValidity()||(this.querySelector('[data-art-quality]')&&!this.querySelector('[data-art-quality]').checkValidity())){event.preventDefault();event.stopImmediatePropagation();form.reportValidity();}},true);
  form.addEventListener('reset',()=>setTimeout(sync,0));
 }
 sync();
}});
